module.exports = __webpack_public_path__ + "static/media/warning.afc44e3a.svg";